import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { FilterItem } from "./FilterItem";
import "./Portfolio.css";
import PortfolioItem, { PortfolioItemProps } from "./PortfolioItem";

export const data: PortfolioItemProps[] = [
  {
    id: 0,
    title: "Hallucinations vs Semantic Uncertainties",
    description: "Investigated the relationship between semantic uncertainty, lexical similarity, and hallucinations in ML models.",
    imageUrl: "Hallu.png",
    link: "",
    github: "https://github.com/YashShivhare007/HallucinationsVSSemantic_Uncertainties",
    stack: ["NLP", "Deep Learning", "Analytical Skills", "CodeReview"],
    filters: ["all","ML","data"],
  },
  {
    id: 1,
    title: "Ramayana For Everyone",
    description:
      " Designed and developed an interactive map showcasing the Ramayana.Combined narrative visualization with cultural education.",
    imageUrl: "Ramayana.png",
    link: "https://chroniclesofsrirama.netlify.app/",
    github: "",
    stack: [
      "React.js",
      "TailwindCSS",
      "Typescript",
      "Leaflet.js",
      "smtpJS",
      "Typescript",
      "Framer Motion",
    ],
    filters: ["all", "web", "mobile"],
  },
  {
    id: 2,
    title: "Historical Capitals of India",
    description:
      "An interactive website that maps the early capitals of India interactively and provides detailed information about it. Has feedback and a fine-tuned Chatbot functionality.",
    imageUrl: "History.png",
    link: "https://historical-indian-cities.netlify.app/",
    github: "https://github.com/rayaankhan/historic-capitals-india-btp2",
    stack: [
      "React.js",
      "TailwindCSS",
      "Typescript",
      "Leaflet.js",
      "smtpJS",
      "Typescript",
      "Framer Motion",
    ],
    filters: ["all", "web", "mobile"],
  },
  {
    id: 3,
    title: "Social Media Personality Detector",
    description:
      "Built a model classifying personality using Myer's Briggs method based on Twitter and LinkedIn data.(Placed 4th out of 25 teams in Megathon 2023.)",
    imageUrl: "Konnect.png",
    link: "",
    github: "https://github.com/YashShivhare007/Megathon2K23",
    stack: ["ReactJS", "Python", "Web Scraping", "Problem Solving"],
    filters: ["all", "ML","data"],
  },
  {
    id: 4,
    title: "Greddit",
    description:
      "Created a MERN stack-based Reddit clone featuring user authentication, posts, pages, and follower functionalities.",
    imageUrl: "Greddit.png",
    link: "",
    github: "https://github.com/Design-Analysis-of-Software-Systems/Greddit",
    stack: [
      "MongoDB",
      "React.js",
      "MERN Stack",
      "Application Programming Interfaces (API)",
      "Node.js",
      "Code Review",
      "Express.js",
      "socket.io",
    ],
    filters: ["all", "web","mobile"],
  },
  {
    id: 5,
    title: "Modular Shell",
    description: "Created a modular shell using C with features like IO redirection, piping,auto-completion, background processes, and signal handling.Helps in using CLI more efficiently using shortcuts and new functionalities introduced",
    imageUrl: "OSN.png",
    link: "",
    github: "https://github.com/OperatingSystem-OSN/Modular-Shell",
    stack: ["Java", "GUI"],
    filters: ["all", "other","OS"],
  },
  {
    id: 6,
    title: "Scribbl.io-Clone App",
    description: "• Developed a clone of the Scribbl.io game using Flutter, NodeJs, and MongoDB. Has low latency and live chat functionality.",
    imageUrl: "Scribbl.png",
    link: "",
    github: "https://github.com/Design-Analysis-of-Software-Systems/Scribbl.io",
    stack: ["Dart","C++","HTML","Javascript","socket.io","Flutter"],
    filters: ["all", "game"],
  },
  {
    id: 7,
    title: "Global Health Committee: Mini-World",
    description:
      "Implemented a Python and SQLite CLI to manage a SQL database for a pseudo Global Health Committee. Enabled data retrieval and modification",
    imageUrl: "GHC.png",
    link: "",
    github: "https://github.com/DatabaseManagementSystem-DBMS/Global-Health-Committee",
    stack: ["SQLite3", "Python"],
    filters: ["all", "data"],
  },
];

interface PortfolioProps {
  standalone: boolean;
}

export function Portfolio({ standalone }: PortfolioProps) {
  // let items: PortfolioItem[] = [];
  // let items: PortfolioItemProps[];
  let filters: string[] = [
    "all",
    "web",
    "mobile",
    "ML",
    "game",
    "data",
    "OS",
  ];
  const [currentFilter, setCurrentFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div
      className="portfolio-page flex"
      initial={{ x: -window.innerWidth }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: window.innerWidth, transition: { duration: 0.5 } }}
    >
      <div className="portfolio-page-container screen-max">
        {standalone ? (
          <>
            <br></br>
            <br></br>
            <br></br>
            <br></br>
          </>
        ) : null}
        <div className="portfolio-title section-title">
          Portfolio <span>.</span>
        </div>

        {/* Filters */}
        <div className="filters-container flex">
          {filters.map((filter, index) => (
            <FilterItem
              key={index}
              title={filter}
              initialClicked={filter === "all" ? true : false}
              setCurrentFilter={setCurrentFilter}
              currentFilter={currentFilter}
            />
          ))}
        </div>

        {/* Filtered Items */}
        <div className="portfolio-items-container">
          {
            data.map((item) => {
              if (item.filters.includes(currentFilter)) {
                return (
                  <PortfolioItem
                    key={item.id}
                    id={item.id}
                    title={item.title}
                    description={item.description}
                    imageUrl={item.imageUrl}
                    link={item.link}
                    github={item.github}
                    stack={item.stack}
                    filters={item.filters}
                  />
                );
              } else {
                return null;
              }
            })
          }
        </div>
      </div>
    </motion.div>
  );
}
